import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaSuppliers component.
 */
const FichaSuppliers = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Proveedores.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Se listan los ocho proveedores con mayor monto transado durante el año seleccionado.</Item>
        <Item>Nombre del proveedor y monto total transado durante el año.</Item>
        <Item>Clic en ver detalle para conocer información detallada del proveedor.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaSuppliers
